var _templateObject, _templateObject2, _templateObject3, _templateObject4;
function _taggedTemplateLiteral(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
    raw: {
      value: Object.freeze(t)
    }
  }));
}
import { Box } from '@creditas-ui/layout';
import { css, styled } from '@creditas-ui/system';
import { getTypography, ifProp } from '@creditas-ui/utilities';
export var base = _ref => {
  var {
    theme: {
      button
    }
  } = _ref;
  return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  cursor: pointer;\n  border: none;\n  overflow: hidden;\n  color: ", ";\n  background-color: transparent;\n  transition: all ", ";\n  padding: ", ";\n"])), button('secondary.fontColor'), button('secondary.transitionMotion'), button('secondary.padding'));
};
export var disabled = _ref2 => {
  var {
    theme: {
      button
    }
  } = _ref2;
  return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  color: ", ";\n  cursor: not-allowed;\n"])), button('secondary.disabledFontColor'));
};
export var hover = _ref3 => {
  var {
    theme: {
      button
    }
  } = _ref3;
  return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  opacity: ", ";\n"])), button('secondary.opacityHover'));
};
var sizesSelector = {
  medium: getTypography('bodySmMedium'),
  large: getTypography('bodyMdMedium')
};
export var ButtonSecondaryElement = styled(Box.withComponent('button', process.env.NODE_ENV === "production" ? {
  target: "eypxca20"
} : {
  target: "eypxca20",
  label: "ButtonSecondaryElement"
}))(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  ", "\n  ", ";\n\n  ", "\n\n  &:hover {\n    ", ";\n  }\n"])), base, ifProp({
  disabled: true
}, disabled), _ref4 => {
  var {
    size
  } = _ref4;
  return sizesSelector[size];
}, ifProp({
  disabled: false
}, hover));